export default __webpack_public_path__ + "static/media/treasure-chest.284bce02.png";